import React from 'react';
import * as styles from './ControlButton.module.scss';
import classNames from 'classnames';

export default function ControlButton({
  className,
  small,
  disabled,
  children,
  onClick,
  ...rest
}) {
  return (
    <button
      className={classNames(styles.button, className, {
        [styles.small]: small,
        [styles.disabled]: disabled
      })}
      disabled={disabled}
      onClick={e => {
        if (!disabled && onClick) {
          onClick(e);
        }
      }}
      {...rest}
    >
      <div className={styles.buttonContent}>{children}</div>
      <div className={styles.overlay} />
    </button>
  );
}
